<template>
  <l-rows>
    <validation-provider
      v-slot="{ errors }"
      rules="required"
      :name="label"
      vid="adapterSelect"
      slim
    >
      <m-input-select
        :label="label"
        :help-danger="errors[0]"
        :loading="adaptersMeta.loading"
        :options="adapterOptions"
        :value="value && value.adapterId"
        @input="handleAdapterSelect"
      />
    </validation-provider>
    <AdapterConfiguration
      v-if="value != null"
      :config-variables="value.config"
      @configChange="handleConfigChange"
    />
  </l-rows>
</template>

<script>
  import { MInputSelect, LRows } from 'codefabrik-gui-vue'
  import { adapterService } from '@/services'
  import AdapterConfiguration from './AdapterConfiguration'
  import { useQuery } from 'codefabrik-gui-vue/src/apollo'
  import { ValidationProvider } from 'vee-validate'

  function toAdapterOptions (adapterData) {
    return adapterData.adapter.map(adapter => {
      return {
        value: adapter.id,
        label: adapter.type,
        configVariables: adapter.configVariables
      }
    })
  }

  export default {
    name: 'AdapterSelect',
    components: { AdapterConfiguration, MInputSelect, ValidationProvider, LRows },
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: Object,
        default: () => {
        }
      },
      errorMessage: {
        type: String,
        default: null
      }
    },
    mixins: [
      useQuery({
        name: 'adapters',
        serviceFn: adapterService.getAdapters,
        mappingFunctions: {
          adapterOptions: [
            (adapterData) => toAdapterOptions(adapterData),
            () => []]
        }
      })
    ],
    methods: {
      handleAdapterSelect (newValue) {
        const selectedAdapter = this.adapterOptions.find(it => it.value === newValue)
        this.$emit('input', {
          adapterId: newValue,
          config: selectedAdapter.configVariables.map((key) => ({ key, value: '' }))
        })
      },
      handleConfigChange (config) {
        this.$emit('input', { ...this.value, config })
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
>
</style>
